import logo from './logo.svg';
import './App.css';

import React from 'react';
import DonationBlink from './DonationBlink';

function App() {
  return (
    <div className="App">
      <DonationBlink />
    </div>
  );
}

export default App;
